// Mixpanel の Pageview に送るパス。
//
// location.pathname をそのまま送ると、/api-keys/<キーの ID> のように可変の
// セグメントを含むパスが1件ずつ別の値として記録され、画面ごとの閲覧数を
// 数えられない。ルート定義と同じ形に丸めてから送る。
//
// パラメータを含むルートを Router.tsx に追加したときは、ここにも追加する。
const DYNAMIC_ROUTES: { matcher: RegExp; path: string }[] = [
  { matcher: /^\/api-keys\/[^/]+$/, path: '/api-keys/:id' },
];

const trackingPath = (pathname: string): string => {
  if (!pathname) {
    return '/';
  }

  // 末尾のスラッシュは同じ画面を指すので、照合の前に落とす。
  const normalized = pathname.replace(/\/+$/, '') || '/';

  const dynamicRoute = DYNAMIC_ROUTES.find(({ matcher }) => matcher.test(normalized));

  return dynamicRoute ? dynamicRoute.path : normalized;
};

export default trackingPath;
